module.exports = __webpack_public_path__ + "img/Chile.609bb306.png";